import React from 'react';

import {
  Container,
  DayWrapper,
  WeekDay,
  Day,
  StatusWrapper,
  Status,
} from './styles';

type StatusType = 'em_rota' | 'fora_de_rota' | 'indisponivel';

type DayCardProps = {
  onClick: () => void;
  weekDay: string;
  day: string;
  status: StatusType;
  isToday: boolean;
  isSelected: boolean;
};

const DayCard: React.FC<DayCardProps> = ({
  onClick,
  weekDay,
  day,
  status,
  isToday,
  isSelected,
}) => {
  const statusColor = {
    em_rota: '#0b29fb',
    fora_de_rota: '#3d3d3d',
    indisponivel: '#eff0f0',
  };

  const statusText = {
    em_rota: 'Dia de rota',
    fora_de_rota: 'Fora de rota',
    indisponivel: 'Indisponível',
  };

  return (
    <Container
      onClick={onClick}
      isUnabailable={status === 'indisponivel'}
      isToday={isToday}
      isSelected={isSelected}
    >
      <DayWrapper>
        <WeekDay isUnabailable={status === 'indisponivel'}>{weekDay}</WeekDay>
        <Day isUnabailable={status === 'indisponivel'}>{day}</Day>
      </DayWrapper>
      <StatusWrapper
        isUnabailable={status === 'indisponivel'}
        bgColor={statusColor[status]}
      >
        <Status isUnabailable={status === 'indisponivel'}>
          {statusText[status]}
        </Status>
      </StatusWrapper>
    </Container>
  );
};

export default DayCard;
